
import {connect} from 'react-redux';
import axios from 'axios';

import {Alert, Platform} from "react-native"

import UploadDocumentSatiaScreen from '../UploadDocumentSatiaScreen';

import store from "../../../../../redux/store";
import {typeExport} from "../../../../../redux/store/type";
import {
    serviceActionSetState,
    serviceActionSetToken,
    serviceActionSetUser,
    serviceActionSetWallet
} from "../../../splash/action/ActionSplashSatiaScreen";

const mapStateToProps = (state) => ({
    results: state.reducerUploadDocumentSatiaScreen.results,
    NoInternetDialog: state.reducerUploadDocumentSatiaScreen.NoInternetDialog,
    isLoading: state.reducerUploadDocumentSatiaScreen.isLoading,
    TypeDocumentsList: state.reducerUploadDocumentSatiaScreen.TypeDocumentsList,

    user: state.reducerSplashSatiaScreen.user,
    token: state.reducerSplashSatiaScreen.token,

});

const mapDispatchToProps = (dispatch) => ({
    callService: (url, params, type, typeConnection, token) => dispatch(callWebservice(url, params, type, typeConnection, token)),
    callServiceSetUser: (user) => dispatch(serviceActionSetUser(user)),
    callserviceActionRefresh: (user) => dispatch(serviceActionRefresh(user)),
    callServiceSetToken: (token) => dispatch(serviceActionSetToken(token)),
    callServiceSetWallet: (data, typeWallet) => dispatch(serviceActionSetWallet(data, typeWallet)),
    callServiceSetState: (data) => dispatch(serviceActionSetState(data)),


})

const getDataDisatch = (dispatch, url, params, type, typeConnection, token) => {
    dispatch(serviceActionPending());

    /* axios(
         {
             url: baseUrl + url + params,
             method: typeConnection,
             headers: {
                 'Content-Type': 'application/x-www-form-urlencoded',
                 "Authorization":  token,

             },

         }
     )*/
    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            // 'Content-Type': 'application/json',
            "Authorization": `Basic ${params.token}`
        }
    };
    const formData = new FormData();

    formData.append('lang', params.lang);
    formData.append('token', params.token);
    formData.append('token_fb', store.getState().reducerSplashSatiaScreen.token_fb);
    formData.append('customer', store.getState().reducerSplashSatiaScreen.Account ? JSON.stringify(store.getState().reducerSplashSatiaScreen.Account) : null);


    axios({
        method: 'post',
        url: url,
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
        timeout: typeExport._TIMEOUT,

    })
   // axios.post(url, formData, config)
        .then(async response => {
            // let data = response.data;
            let data = response.data.result && response.data.result.data ? response.data.result.data : response.data.result;

            switch (type) {

                case typeExport.TypeGetUploadDocumentSatiaScreen:
                    // alert("fghfg")
                    // HMAlert(i18n.t('constant.message'), "ویرایش با موقیت انجام شد", [
                    //         // {text: 'Ask me later', onPress: () => {}},
                    //         // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    //         {text: i18n.t('constant.ok'), onPress: () => NavigationService.Pop()},
                    //     ],
                    //     {cancelable: true}
                    // )
                    if (response.data.status) {
                        dispatch(serviceActionSuccess(data, response.data.category?response.data.category:[]))

                    } else {
                        dispatch(serviceActionError(response))

                    }

                    break;
                default:
            }
        }).catch((e) => {
        dispatch(serviceActionError(e))
    })
}


export const callWebservice = (url, params, type, typeConnection, token) => {

    return dispatch => {


        // NetInfo.isConnected.fetch().then(isConnected => {
        //     if (isConnected) {
        //         getDataDisatch(dispatch, url, params, type, typeConnection,token);
        //     }
        //     else {
        //         dispatch(serviceActionError("No Internet Connection"));
        //     }
        // });

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection"));
        //         }
        //     }
        // )


        if (store.getState().reducerSplashSatiaScreen.Connection) {
            getDataDisatch(dispatch, url, params, type, typeConnection, token);
        } else {
            dispatch(serviceActionError("No Internet Connection"));
        }


        // NetInfo.getConnectionInfo().).done(
        //     (isConnected) => {
        //
        //     }
        // )

    }
}


export const serviceActionPending = () => ({
    type:  typeExport.UploadDocumentSatiaScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    results: null

})

export const serviceActionError = (error) => ({
    type:  typeExport.UploadDocumentSatiaScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    isLoading: false,
    error: error
})

export const serviceActionSuccess = (data, category) => ({
    type:  typeExport.UploadDocumentSatiaScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    isLoading: false,
    results: data,
    TypeDocumentsList: category,
})

export const serviceActionRefresh = () => ({
    type:  typeExport.UploadDocumentSatiaScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    isLoading: false,
    results: null
})
export default connect(mapStateToProps, mapDispatchToProps)(UploadDocumentSatiaScreen);
